'use client';
import { SelectedMenus, Template } from '@zeus/shared';
import { forwardRef, memo, useEffect, useState } from 'react';
import Category from '../category';
import {
  // extractFontFamilyFromUrl,
  getActiveCategories,
  getScaleSize,
  isBetweenRange,
} from '../../../../../utils/utils';
import { BoxComponent } from '../../../../../base/box/Box';
import { useNormalizedPixels } from '../../../../../hooks/useResize';

interface TemplateMenu {
  menu: SelectedMenus | null;
  template: Omit<Template, 'content'>;
  development?: boolean;
  timezone?: string;
  scale?: number;
  tenantId?: number;
}

const Menu = forwardRef<HTMLDivElement, TemplateMenu>((props, ref) => {
  const { menu, template, development, timezone, scale = 1, tenantId } = props;

  const [active, setActive] = useState<boolean | null>(true);
  const { normalizePixels } = useNormalizedPixels();

  useEffect(() => {
    if (development === false) {
      const intervalId = setInterval(() => {
        setActive(isBetweenRange(menu?.schedules, timezone));
      }, 10000);

      return () => clearInterval(intervalId);
    }
  }, []);

  const isDevelopment = development ? true : isBetweenRange(menu?.schedules, timezone);
  const hasBrandLogo = template?.brandLogo && template?.brandLogo?.isEnabled && template?.brandLogo?.image;
  const isCategoryEnabled = template?.category?.isEnabled ?? true;
  const categories = getActiveCategories(menu, timezone, development);
  const lastCategoryIndex = categories.length - 1;
  // const fontFamily = extractFontFamilyFromUrl(template?.fontFamily);
  const fontFamily = template?.fontFamilyName;
  return (
    active && (
      <>
        {isDevelopment && (
          <section
            id="ref-component"
            ref={ref}
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              columnCount: getScaleSize(normalizePixels(10, 'width'), scale),
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
            }}
          >
            <BoxComponent
              sx={{
                ...(!isCategoryEnabled && hasBrandLogo
                  ? {
                      mt: getScaleSize(normalizePixels(70, 'height'), scale),
                    }
                  : {}),
              }}
            >
              {categories?.map((category, categoryIndex) => (
                <Category
                  key={`${category.id}-${active}`}
                  category={category}
                  template={template}
                  development={development}
                  timezone={timezone}
                  scale={scale}
                  categoryIndex={categoryIndex}
                  tenantId={tenantId}
                  lastCategoryIndex={lastCategoryIndex}
                  fontFamily={fontFamily}
                />
              ))}
            </BoxComponent>
          </section>
        )}
      </>
    )
  );
});

export default memo(Menu);
